function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 2.42103C0 1.84382 0.202708 1.36763 0.608108 0.992458C1.01351 0.617272 1.54055 0.429688 2.18919 0.429688C2.82626 0.429688 3.34169 0.61438 3.73552 0.9838C4.14092 1.36475 4.34363 1.86113 4.34363 2.47298C4.34363 3.02709 4.14672 3.48884 3.7529 3.85826C3.3475 4.23921 2.81467 4.42969 2.15444 4.42969H2.13707C1.49999 4.42969 0.984562 4.23921 0.590734 3.85826C0.196905 3.47731 0 2.99822 0 2.42103ZM0.225869 17.5725V6.00544H4.08301V17.5725H0.225869ZM6.22008 17.5725H10.0772V11.1137C10.0772 10.7096 10.1236 10.3979 10.2162 10.1786C10.3784 9.7861 10.6245 9.4542 10.9546 9.18293C11.2847 8.91164 11.6988 8.776 12.1969 8.776C13.4942 8.776 14.1429 9.64757 14.1429 11.3907V17.5725H18V10.9405C18 9.23199 17.5946 7.93618 16.7838 7.05306C15.973 6.16994 14.9015 5.72839 13.5695 5.72839C12.0753 5.72839 10.9112 6.36908 10.0772 7.65046V7.6851H10.0598L10.0772 7.65046V6.00544H6.22008C6.24324 6.37485 6.25483 7.52347 6.25483 9.45133C6.25483 11.3792 6.24324 14.0862 6.22008 17.5725Z",
  fill: "#FAF9FC"
});
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/LinkedIn.b918d7f1933716033eae73e707303947.svg";
export { ForwardRef as ReactComponent };